import {
  faBriefcaseClock,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Card, Col, Row, Tab, Table, Tabs } from "react-bootstrap";
import { FaBriefcase } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Pagination from "../../Pagination";
import "./CandidateDashboard.css";
import DashboardLayout from "./DashboardLayout";
import GlobalCandidateSettings from "./GlobalCandidateSettings";
import ResumeSelectionPopup from "./ResumeSelectionPopup";

const CandidateJobs = () => {
  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const userName = location.state?.userName;
  const userId = location.state?.userId;
  const initialTab = location.state?.tab || "all"; // Default to 'all' if no tab is specified
  const [key, setKey] = useState(initialTab);
  const navigate = useNavigate();
  const [jobs, setJobs] = useState([]);
  const [applyjobs, setApplyJobs] = useState([]);
  const [showResumePopup, setShowResumePopup] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20); // Default page size
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [resumes, setResumes] = useState([]);
  const [hasUserApplied, setHasUserApplied] = useState({});
  const [selectedJobSummary, setSelectedJobSummary] = useState(null);
  const [filterStatus, setFilterStatus] = useState("all");
  const [loading, setLoading] = useState(false); // State to manage loading
  const [preferences, setPreferences] = useState();
  const [aiJobs, setAiJobs] = useState([]);
  const [loadingAiJobs, setLoadingAiJobs] = useState(false); // Loading state for AI jobs
  const [selectedExperience, setSelectedExperience] = useState(
    "No experience selected",
  );
  const [noJobsDueToAreaOfWork, setNoJobsDueToAreaOfWork] = useState(false);
  const [areaOfWorkValue, setAreaOfWorkValue] = useState("");
  const [isResumesLoading, setIsResumesLoading] = useState(false);

  useEffect(() => {
    console.log("========== JOB EFFECT ==========");
    console.log("search:", search);
    console.log("filterStatus:", filterStatus);
    console.log("selectedExperience:", selectedExperience);
    console.log("page:", page);
    console.log("pageSize:", pageSize);
    console.log("================================");

    if (selectedExperience === "No experience selected") {
      if (search && filterStatus) {
        console.log("Calling searchJobsWithFilter()");
        searchJobsWithFilter(search, filterStatus);
      } else if (search) {
        console.log("Calling fetchJobBySearch()");
        fetchJobBySearch(search);
      } else if (filterStatus && filterStatus !== "all") {
        console.log("Calling fetchDataByFilter()");
        fetchDataByFilter(filterStatus);
      } else {
        console.log("Calling fetchData() → paginationJobs");
        fetchData();
      }
    } else {
      const range = getExperienceRange(selectedExperience);

      if (range) {
        const [minExp, maxExp] = range;

        console.log("Calling fetchJobsByExperience()", minExp, maxExp);

        fetchJobsByExperience(minExp, maxExp);
      }
    }
  }, [
    page,
    pageSize,
    search,
    sortedColumn,
    sortOrder,
    filterStatus,
    selectedExperience,
    userId,
  ]);

  const handleFilterChange = async (e) => {
    const status = e.target.value;
    setFilterStatus(status);
    localStorage.setItem("candidateJobsPage", 0);
    setPage(0);
  };
  useEffect(() => {
    // Ensure that fetchPreferences only runs if either userId or key is defined
    if (userId && key !== "all") {
      fetchPreferences();
    }
  }, [userId, key]); // This effect will run when userId or key changes

  const TWO_HOURS = 2 * 60 * 60 * 1000; // 2 hours in milliseconds
  //const FIVE_MINUTES = 5 * 60 * 1000; // 2 hours in milliseconds

  const fetchPreferences = async () => {
    const now = Date.now();
    const savedTime = localStorage.getItem("preferencesTimestamp" + userId);

    // Check if stored data is older than 2 hours, if yes clear it    2 hours.
    if (savedTime && now - parseInt(savedTime, 10) > TWO_HOURS) {
      // console.log("Saved time is older than 5 minutes Clearing local storage.");
      localStorage.removeItem("preferences" + userId);
      localStorage.removeItem("aiJobs" + userId);
      localStorage.removeItem("preferencesTimestamp" + userId);
    } else {
      // console.log("Saved time is not older than 5 minutes Clearing local storage.");
    }

    // Re-fetch data from localStorage after potential removal
    const storedPreferences = JSON.parse(
      localStorage.getItem("preferences" + userId),
    );
    const storedAiJobs = JSON.parse(localStorage.getItem("aiJobs" + userId));

    try {
      const response = await axios.get(
        `${BASE_API_URL}/getPreferencesByUserId`,
        {
          params: { userId },
        },
      );

      if (!response.data) {
        // console.log("API returned null or undefined data.");
        return;
      }

      const fetchedPreferences = response.data;
      setPreferences(fetchedPreferences);

      if (
        storedPreferences &&
        JSON.stringify(storedPreferences) === JSON.stringify(fetchedPreferences)
      ) {
        // console.log("Preferences have not changed.");
        if (storedAiJobs !== null) {
          // console.log("Using stored AI jobs.");
          setAiJobs(storedAiJobs);
        } else {
          //  console.log("Stored AI jobs are missing. Fetching from API.");
          fetchAiJobs(fetchedPreferences);
        }
      } else {
        // console.log("Preferences have changed. Fetching new AI jobs.");
        fetchAiJobs(fetchedPreferences);
      }

      // Store the latest preferences and timestamp
      localStorage.setItem(
        "preferences" + userId,
        JSON.stringify(fetchedPreferences),
      );
      localStorage.setItem("preferencesTimestamp" + userId, now.toString());
    } catch (error) {
      console.error("Error fetching preferences:", error);
    }
  };

  const fetchAiJobs = async (preferences, skipAreaOfWork = false) => {
    try {
      setLoadingAiJobs(true);
      setNoJobsDueToAreaOfWork(false);
      setAreaOfWorkValue("");

      const isLocalhost = window.location.hostname === "localhost";
      const apiPath = isLocalhost
        ? "/scrapeJobsByPreferencesForLocalHost"
        : "/scrapeJobsByPreferences";

      const params = {
        userId: userId,
        jobTitle: preferences.jobTitle,
        location: preferences.location,
        expeirence: preferences.expeirence,
        areaOfWork: skipAreaOfWork ? null : preferences.areaOfWork,
        notToApplyCompanies: preferences.notToApplyCompanies,
      };
      const response = await axios.get(`${BASE_API_URL}${apiPath}`, { params });

      // Process job data
      const processedJobs = response.data.map((job) => ({
        ...job,
        salary:
          job.salary && job.salary !== ""
            ? job.salary
            : "Salary is not disclosed",
        postingDays:
          job.postingDays && job.postingDays !== ""
            ? job.postingDays
            : "Posted date is not available",
      }));

      // Set the fetched AI jobs in state
      setAiJobs(processedJobs);

      // If no jobs found and area of work was specified, set the flag
      if (
        processedJobs.length === 0 &&
        preferences.areaOfWork &&
        !skipAreaOfWork
      ) {
        setNoJobsDueToAreaOfWork(true);
        setAreaOfWorkValue(preferences.areaOfWork);
      }

      // Store the jobs in localStorage for future use
      localStorage.setItem("aiJobs" + userId, JSON.stringify(processedJobs));
    } catch (error) {
      console.error("Error fetching AI jobs:", error);
    } finally {
      setLoadingAiJobs(false);
    }
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  // Helper function to get experience range
  const getExperienceRange = (experience) => {
    if (experience === "No experience selected") {
      return null; // Return null to indicate no experience filter
    }

    switch (experience) {
      case "Fresher < 1 year":
        return [0, 1];
      case "1-5 years":
        return [1, 5];
      case "6-10 years":
        return [6, 10];
      case "11-15 years":
        return [11, 15];
      case "16-20 years":
        return [16, 20];
      case "21-25 years":
        return [21, 25];
      case "26-30 years":
        return [26, 30];
      case "30+ years":
        return [30, 100];
      default:
        return null;
    }
  };

  async function fetchData() {
    try {
      setLoading(true);
      const params = {
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder,
      };
      const response = await axios.get(`${BASE_API_URL}/paginationJobs`, {
        params,
      });
      setJobs(response.data.content);
      console.log("response.data.content", response.data.content);
      console.log("jobs", jobs);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  async function fetchDataByFilter(filterStatus) {
    try {
      setLoading(true);
      const params = {
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder,
        userId: userId, // Example parameter to pass to backend API
        filterStatus: filterStatus,
      };

      const response = await axios.get(`${BASE_API_URL}/paginationFilterJobs`, {
        params,
      });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  async function searchJobsWithFilter(search, filterStatus) {
    try {
      setLoading(true);
      const params = {
        search: search,
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder,
        userId: userId, // Example parameter to pass to backend API
        filterStatus: filterStatus,
      };

      const response = await axios.get(`${BASE_API_URL}/searchJobsWithFilter`, {
        params,
      });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  }

  const fetchJobBySearch = async () => {
    try {
      const params = {
        search: search,
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder,
        //  userId: userId, // Example parameter to pass to backend API
        //  filterStatus: filterStatus
      };
      const response = await axios.get(`${BASE_API_URL}/searchJobs`, {
        params,
      });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);

      const statuses = await Promise.all(
        response.data.content.map((job) => hasUserApplied(job.jobId, userId)),
      );
      const statusesMap = {};
      response.data.content.forEach((job, index) => {
        statusesMap[job.jobId] = statuses[index];
      });
    } catch (error) {
      //console.log("No data Found" + error);
    }
    // console.log("Search submitted:", search);
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handleApplyButtonClick = (jobId) => {
    setSelectedJobId(jobId);
    setShowResumePopup(true);
  };

  const handleResumeSelect = async (resumeId) => {
    if (selectedJobId && resumeId) {
      await applyJob(selectedJobId, resumeId);
      setSelectedJobId(null);
      setShowResumePopup(false);
    }
  };
  const [isNewJobsApplied, setIsNewJobsApplied] = useState(false);
  const applyJob = async (jobId, resumeId) => {
    let loadingPopup;

    try {
      // Show loading message using SweetAlert
      loadingPopup = Swal.fire({
        title: "Applying to the job...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const appliedOn = new Date(); // Get current date and time
      const year = appliedOn.getFullYear(); // Get the full year (e.g., 2024)
      const month = String(appliedOn.getMonth() + 1).padStart(2, "0"); // Get month (January is 0, so we add 1)
      const day = String(appliedOn.getDate()).padStart(2, "0"); // Get day of the month

      const formattedDate = `${year}-${month}-${day}`;

      const response = await axios.put(`${BASE_API_URL}/applyJob`, null, {
        params: { jobId, userId, formattedDate, resumeId },
      });

      if (response.data) {
        setApplyJobs((prevApplyJobs) => [
          ...prevApplyJobs,
          { jobId, formattedDate },
        ]);
        setHasUserApplied((prev) => ({ ...prev, [jobId]: true }));

        setIsNewJobsApplied((prev) => !prev);
        // Close the loading popup
        Swal.close();

        // Show success message
        await Swal.fire({
          icon: "success",
          title: "Apply Successful!",
          text: "You have successfully applied for this job.",
        });
      }
    } catch (error) {
      console.error("Error applying for job:", error);
      // Close loading popup on error
      if (loadingPopup) {
        Swal.close();
      }
      // Show error message
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong! Please try again later.",
      });
    } finally {
      // Ensure loading popup is closed if still open
      if (loadingPopup) {
        Swal.close();
      }
    }
  };

  useEffect(() => {
    setIsResumesLoading(true); // start loading

    axios
      .get(`${BASE_API_URL}/getResume`, { params: { userId } })
      .then((response) => {
        setResumes(response.data);
      })
      .catch((error) => {
        console.error("Error fetching resumes:", error);
        setResumes([]); // clear resumes on error
      })
      .finally(() => {
        setIsResumesLoading(false); // stop loading
      });
  }, [userId]);

  useEffect(() => {
    checkHasUserApplied();
  }, [jobs, userId]);

  const checkHasUserApplied = async () => {
    const applications = {};
    try {
      for (const job of jobs) {
        const response = await axios.get(`${BASE_API_URL}/applicationApplied`, {
          params: { jobId: job.jobId, userId },
        });
        applications[job.jobId] = response.data;
      }
      setHasUserApplied(applications);
    } catch (error) {
      console.error("Error checking application:", error);
    }
  };

  const handleSort = (column) => {
    if (sortedColumn === column) {
      // Toggle sort order if the same column is clicked
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // Sort by the new column (default to ascending)
      setSortedColumn(column);
      setSortOrder("asc");
    }
  };
  const handleCloseModal = () => {
    setSelectedJobSummary(null);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1)); // Ensure selectedPage is within range
    setPage(selectedPage);
    localStorage.setItem("candidateJobsPage", selectedPage); // Store the page number in localStorage
  };
  useEffect(() => {
    const storedPage = localStorage.getItem("candidateJobsPage");
    if (storedPage !== null) {
      const parsedPage = Number(storedPage);
      if (parsedPage < totalPages) {
        setPage(parsedPage);
      }
    }
  }, [totalPages]);

  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;

  const customTabHeader = (title, icon) => (
    <div className="d-flex align-items-center">
      <span className="me-2">
        {/* <i className={icon} /> */}
        {icon}
      </span>
      <span class="fs-6 fw-bold">{title}</span>
    </div>
  );
  function handleScroll(event, direction) {
    const wrapper = event.currentTarget.closest(".d-flex");
    const container = wrapper.querySelector(".overflow-auto");
    const scrollAmount = 200;

    if (direction === "left") {
      container.scrollLeft -= scrollAmount;
    } else if (direction === "right") {
      container.scrollLeft += scrollAmount;
    }
  }

  const handleChangeExperience = async (e) => {
    const value = e.target.value;
    setSelectedExperience(value);
    setPage(0); // Reset to first page when filter changes

    if (value === "No experience selected") {
      // If no experience is selected, fetch all jobs
      await fetchData();
      return;
    }

    const [minExp, maxExp] = getExperienceRange(value);
    if (minExp !== null && maxExp !== null) {
      await fetchJobsByExperience(minExp, maxExp);
    }
  };
  const fetchJobsByExperience = async (minExp, maxExp) => {
    try {
      setLoading(true);
      const params = {
        minExp: minExp,
        maxExp: maxExp,
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortDir: sortOrder,
      };

      const response = await axios.get(`${BASE_API_URL}/filterByExperience`, {
        params,
      });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching jobs by experience:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleShare = (job) => {
    const slug = `${job.jobId}-${job.jobTitle
      .replace(/\s+/g, "-")
      .toLowerCase()}-${job.companyName.replace(/\s+/g, "-").toLowerCase()}`;
    const shareUrl = `${window.location.origin}/browse-jobs/job-details/${slug}`;
    //const shareUrl = `${window.location.origin}/job-details/${jobId}`; // Or however your public job link is structured

    if (navigator.share) {
      navigator
        .share({
          title: "Job Opportunity",
          text: "Check out this job!",
          url: shareUrl,
        })
        .then(() => console.log("Job shared successfully"))
        .catch((error) => console.error("Error sharing", error));
    } else {
      navigator.clipboard
        .writeText(shareUrl)
        .then(() => {
          Swal.fire({
            title: "Link Copied!",
            text: "Job link copied to clipboard. You can share it now.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        })
        .catch(() => {
          Swal.fire({
            title: "Error",
            text: "Could not copy link. Please try again.",
            icon: "error",
          });
        });
    }
  };
  return (
    <DashboardLayout>
      <div className="main-content">
        <Row
          className="d-flex justify-content-between align-items-center"
          style={{ marginBottom: "20px" }}
        >
          <Col xs="auto">
            <h2
              className="text-start"
              style={{ paddingLeft: "12px", marginBottom: 0 }}
            >
              Jobs
            </h2>
          </Col>
          <Col xs="auto">
            <GlobalCandidateSettings
              userId={userId}
              isSomeChanges={isNewJobsApplied}
            />
          </Col>
        </Row>

        <Row>
          <Col
            className="filter-action"
            style={{
              paddingTop: "10px",
              marginLeft: "12px",
              marginRight: "12px",
            }}
          >
            <Tabs
              id="application-tabs"
              activeKey={key}
              onSelect={(k) => setKey(k)} // Change active tab on select
              className="mb-3"
            >
              <Tab
                eventKey="all"
                title={customTabHeader("All jobs  ", <FaBriefcase />)}
              >
                {/* Automatically fetch data when this tab is selected */}
                <Row>
                  <Col
                    className="filter-action"
                    md={4}
                    style={{
                      paddingTop: "10px",
                      marginLeft: "12px",
                      marginRight: "12px",
                    }}
                  >
                    <label
                      htmlFor="status"
                      className="form-label"
                      style={{ color: "#6c5b7b" }}
                    >
                      Filter by Actions:
                    </label>
                    <select
                      id="status"
                      className="form-select form-select-sm fs-6"
                      style={{
                        borderColor: "#6c5b7b",
                        borderRadius: "6px",
                        height: "40px", // Match the height of the select
                        width: "100%", // Full width
                      }}
                      onChange={handleFilterChange}
                      value={filterStatus}
                    >
                      <option value="all">Show all</option>
                      <option value="Apply">Yet to apply</option>
                      <option value="Applied">Already applied</option>
                    </select>
                  </Col>
                  <Col
                    className="filter-action"
                    md={4}
                    style={{
                      paddingTop: "10px",
                      marginLeft: "12px",
                      marginRight: "12px",
                    }}
                  >
                    <label
                      htmlFor="status"
                      className="form-label"
                      style={{ color: "#6c5b7b" }}
                    >
                      Select Experience:
                    </label>

                    <select
                      style={{
                        borderColor: "#6c5b7b",
                        borderRadius: "6px",
                        height: "40px",
                        width: "100%",
                      }}
                      onChange={handleChangeExperience}
                      value={selectedExperience}
                    >
                      <option value="No experience selected">
                        No experience selected
                      </option>{" "}
                      {/* Fix typo */}
                      <option value="Fresher < 1 year">
                        Fresher &lt; 1 year
                      </option>
                      <option value="1-5 years">1-5 years</option>
                      <option value="6-10 years">6-10 years</option>
                      <option value="11-15 years">11-15 years</option>
                      <option value="16-20 years">16-20 years</option>
                      <option value="21-25 years">21-25 years</option>
                      <option value="26-30 years">26-30 years</option>
                      <option value="30+ years">30+ years</option>
                    </select>
                  </Col>
                  <Col
                    md={3}
                    className="d-flex align-items-left"
                    style={{ paddingTop: "30px" }}
                  >
                    {/* Search Bar */}
                    <div className="search-bar" style={{ flex: 1 }}>
                      <input
                        style={{
                          borderColor: "#6c5b7b",
                          borderRadius: "6px",
                          height: "40px", // Match the height of the select
                          width: "100%", // Full width
                          padding: "0 10px", // Add horizontal padding for text
                        }}
                        type="text"
                        name="search"
                        placeholder="Search jobs here"
                        value={search}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </Col>
                </Row>

                <br />
                {loading ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="spinner-bubble spinner-bubble-primary m-5" />
                    <span>Loading...</span>
                  </div>
                ) : (
                  jobs.length > 0 && (
                    <div>
                      <Card body>
                        {/* <Card.Title>Light hoverable Table</Card.Title>

                      <p>
                        Add <code>.table-hover</code> to enable a hover state on table rows within a{" "}
                        <code>&lt;tbody&gt;</code>.
                      </p> */}
                        <div className="table-details-list table-wrapper">
                          <Table hover responsive>
                            {" "}
                            {/* className="text-center" */}
                            <thead>
                              <tr>
                                <th
                                  scope="col"
                                  onClick={() => handleSort("jobTitle")}
                                  style={{ cursor: "pointer" }}
                                >
                                  Job Profile{" "}
                                  <span>
                                    <span
                                      style={{
                                        color:
                                          sortedColumn === "jobTitle" &&
                                          sortOrder === "asc"
                                            ? "black"
                                            : "gray",
                                      }}
                                    >
                                      ↑
                                    </span>{" "}
                                    <span
                                      style={{
                                        color:
                                          sortedColumn === "jobTitle" &&
                                          sortOrder === "desc"
                                            ? "black"
                                            : "gray",
                                      }}
                                    >
                                      ↓
                                    </span>
                                  </span>
                                </th>
                                <th
                                  scope="col"
                                  onClick={() => handleSort("companyName")}
                                  style={{ cursor: "pointer" }}
                                >
                                  Company Name{" "}
                                  <span>
                                    <span
                                      style={{
                                        color:
                                          sortedColumn === "companyName" &&
                                          sortOrder === "asc"
                                            ? "black"
                                            : "gray",
                                      }}
                                    >
                                      ↑
                                    </span>{" "}
                                    <span
                                      style={{
                                        color:
                                          sortedColumn === "companyName" &&
                                          sortOrder === "desc"
                                            ? "black"
                                            : "gray",
                                      }}
                                    >
                                      ↓
                                    </span>
                                  </span>
                                </th>
                                <th
                                  scope="col"
                                  onClick={() =>
                                    handleSort("applicationDeadline")
                                  }
                                  style={{ cursor: "pointer" }}
                                >
                                  Application Deadline{" "}
                                  <span>
                                    <span
                                      style={{
                                        color:
                                          sortedColumn ===
                                            "applicationDeadline" &&
                                          sortOrder === "asc"
                                            ? "black"
                                            : "gray",
                                      }}
                                    >
                                      ↑
                                    </span>{" "}
                                    <span
                                      style={{
                                        color:
                                          sortedColumn ===
                                            "applicationDeadline" &&
                                          sortOrder === "desc"
                                            ? "black"
                                            : "gray",
                                      }}
                                    >
                                      ↓
                                    </span>
                                  </span>
                                </th>
                                <th
                                  scope="col"
                                  onClick={() => handleSort("skills")}
                                  style={{ cursor: "pointer" }}
                                >
                                  Skills{" "}
                                  <span>
                                    <span
                                      style={{
                                        color:
                                          sortedColumn === "skills" &&
                                          sortOrder === "asc"
                                            ? "black"
                                            : "gray",
                                      }}
                                    >
                                      ↑
                                    </span>{" "}
                                    <span
                                      style={{
                                        color:
                                          sortedColumn === "skills" &&
                                          sortOrder === "desc"
                                            ? "black"
                                            : "gray",
                                      }}
                                    >
                                      ↓
                                    </span>
                                  </span>
                                </th>
                                <th
                                  scope="col"
                                  onClick={() => handleSort("location")}
                                  style={{ cursor: "pointer" }}
                                >
                                  Location{" "}
                                  <span>
                                    <span
                                      style={{
                                        color:
                                          sortedColumn === "location" &&
                                          sortOrder === "asc"
                                            ? "black"
                                            : "gray",
                                      }}
                                    >
                                      ↑
                                    </span>{" "}
                                    <span
                                      style={{
                                        color:
                                          sortedColumn === "location" &&
                                          sortOrder === "desc"
                                            ? "black"
                                            : "gray",
                                      }}
                                    >
                                      ↓
                                    </span>
                                  </span>
                                </th>
                                <th scope="col">Experience</th>
                                <th scope="col">Job description</th>

                                <th scope="col">Actions</th>
                                <th>Share</th>
                              </tr>
                            </thead>
                            <tbody>
                              {jobs.map((job) => (
                                <tr key={job.id} id="job-table-list">
                                  <td
                                    title={
                                      job.jobCategory === "evergreen" &&
                                      !job.applicationDeadline
                                        ? "This position is always open for hiring, feel free to apply anytime!"
                                        : ""
                                    }
                                  >
                                    {job.jobTitle}
                                  </td>
                                  <td>{job.companyName}</td>
                                  <td>
                                    {job.jobCategory === "evergreen" &&
                                    !job.applicationDeadline ? (
                                      <span
                                        style={{
                                          color: "green",
                                          fontWeight: "bold",
                                        }}
                                        title="This position is always open for hiring, feel free to apply anytime!"
                                      >
                                        Evergreen Job - No Due Date
                                      </span>
                                    ) : (
                                      job.applicationDeadline || "Not Specified"
                                    )}
                                  </td>
                                  <td>{job.skills}</td>
                                  <td>{job.location}</td>
                                  <td>
                                    {job.minExp === 0 && job.maxExp === 0
                                      ? "Fresher"
                                      : `${job.minExp} - ${job.maxExp} years`}
                                  </td>

                                  <td>
                                    <Button
                                      variant="secondary"
                                      className="description btn-rounded"
                                      onClick={() => {
                                        const baseUrl =
                                          "/candidate-dashboard/jobs/job-description/";
                                        const slug = `${job.jobId}-${job.jobTitle.replace(/\s+/g, "-").toLowerCase()}-${job.companyName.replace(/\s+/g, "-").toLowerCase()}`;

                                        // Store data in localStorage
                                        localStorage.setItem(
                                          "userIdForJobDec",
                                          userId,
                                        );
                                        localStorage.setItem(
                                          "userNameForJobDec",
                                          userName,
                                        );

                                        const fullUrl = `${window.location.origin}${baseUrl}${slug}`;
                                        window.open(
                                          fullUrl,
                                          "_blank",
                                          "noopener,noreferrer",
                                        );
                                      }}
                                    >
                                      View
                                    </Button>
                                  </td>
                                  <td>
                                    {hasUserApplied[job.jobId] === true ||
                                    (applyjobs &&
                                      applyjobs.jobId === job.jobId) ? (
                                      <p>Applied</p>
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          handleApplyButtonClick(job.jobId)
                                        }
                                      >
                                        Apply
                                      </Button>
                                    )}
                                  </td>
                                  <td>
                                    <Button
                                      variant="success"
                                      onClick={() => handleShare(job)}
                                    >
                                      {/* <MdShare size={18}/> Share */} Share
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                        <Pagination
                          page={page}
                          pageSize={pageSize}
                          totalPages={totalPages}
                          handlePageSizeChange={handlePageSizeChange}
                          isPageSizeDisabled={isPageSizeDisabled}
                          handlePageClick={handlePageClick}
                        />
                      </Card>

                      {selectedJobSummary && (
                        <div className="modal-summary">
                          <div className="modal-content-summary">
                            <span className="close" onClick={handleCloseModal}>
                              &times;
                            </span>
                            <div className="job-summary">
                              <h3>Job Summary</h3>
                              <pre className="job-details-text">
                                {selectedJobSummary}
                              </pre>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                )}
                {!loading && jobs.length === 0 && <h1>No jobs found.</h1>}
              </Tab>

              <Tab
                eventKey="aijobs"
                title={customTabHeader(
                  "AI match jobs  ",
                  <FontAwesomeIcon icon={faBriefcaseClock} />,
                )}
              >
                {!preferences ? (
                  <div className="d-flex justify-content-center align-items-center flex-column">
                    <h5>
                      Please fill out your job preferences to see the AI matched
                      jobs.
                    </h5>
                    <Button
                      variant="outline-primary"
                      onClick={() =>
                        navigate("/candidate-dashboard/jobPreferences", {
                          state: {
                            userId: userId,
                            userName: userName,
                            preference: "preference",
                          },
                        })
                      }
                    >
                      Click Here to Fill Preferences
                    </Button>
                  </div>
                ) : loadingAiJobs ? (
                  <div className="d-flex justify-content-center align-items-center">
                    <div className="spinner-bubble spinner-bubble-primary m-5" />
                    <span>Loading AI jobs...</span>
                  </div>
                ) : noJobsDueToAreaOfWork ? (
                  <div className="d-flex justify-content-center align-items-center flex-column">
                    <h5>No jobs found for area of work: {areaOfWorkValue}</h5>
                    <p>
                      Would you like to see jobs without this area of work
                      filter?
                    </p>
                    <Button
                      variant="primary"
                      onClick={() => fetchAiJobs(preferences, true)}
                    >
                      Try Again
                    </Button>
                  </div>
                ) : aiJobs.length > 0 ? (
                  <Row>
                    <div className="table-details-list table-wrapper">
                      <Table hover responsive>
                        <thead>
                          <tr>
                            <th>Job Title</th>
                            <th>Company</th>
                            <th>Location</th>
                            <th>Salary</th>
                            <th>Posted on</th>
                            <th>Apply Links</th>
                          </tr>
                        </thead>
                        <tbody>
                          {aiJobs.map((job) => (
                            <tr key={job.id}>
                              <td className="fw-bold">{job.jobTitle}</td>
                              <td>{job.companyName}</td>
                              <td>{job.location}</td>
                              <td>{job.salary || "Salary is not disclosed"}</td>
                              <td>{job.postingDays?.split("T")[0]}</td>
                              <td>
                                <div className="d-flex align-items-center">
                                  {/* Left Arrow */}
                                  <span
                                    className="me-2"
                                    onClick={(e) => handleScroll(e, "left")}
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "0.8rem",
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                  </span>

                                  {/* Scrollable Container */}
                                  <div
                                    id={`scroll-container-${job.id}`}
                                    className="d-flex overflow-auto flex-nowrap"
                                    style={{
                                      maxWidth: "300px",
                                      scrollBehavior: "smooth",
                                    }}
                                  >
                                    {job.applyLinksList &&
                                    Object.entries(job.applyLinksList).length >
                                      0 ? (
                                      Object.entries(job.applyLinksList).map(
                                        ([title, link], index) => (
                                          <Button
                                            key={index}
                                            variant="outline-primary"
                                            className="me-2 mb-1"
                                            style={{
                                              whiteSpace: "nowrap",
                                              flex: "0 0 auto",
                                            }}
                                            onClick={() =>
                                              window.open(link, "_blank")
                                            }
                                          >
                                            {title}
                                          </Button>
                                        ),
                                      )
                                    ) : (
                                      <span className="text-muted">
                                        No links
                                      </span>
                                    )}
                                  </div>

                                  {/* Right Arrow */}
                                  <span
                                    className="ms-2"
                                    onClick={(e) => handleScroll(e, "right")}
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "0.8rem",
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faChevronRight} />
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </Row>
                ) : (
                  <div>
                    <p>Sorry, no jobs available for you right now!</p>
                  </div>
                )}
              </Tab>
            </Tabs>
          </Col>
        </Row>
        {key !== "aiJobs" && (
          <div className="dream p-3">
            <p className="text-center responsive-text">
              Can't find your dream company or dream job? Don't worry, you can
              still apply to them.
            </p>
            <p className="text-center responsive-text">
              Just add the name of your dream company and job role and apply to
              them directly.
            </p>
            <div className="app d-flex flex-column flex-md-row justify-content-center align-items-center gap-3">
              <Button
                variant="primary"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/candidate-dashboard/jobs/dream-company/step/1", {
                    state: { userName, userId },
                  });
                }}
                className="w-md-auto"
              >
                Apply to your dream company
              </Button>

              <Button
                variant="success"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/candidate-dashboard/jobs/dream-job", {
                    state: { userName, userId },
                  });
                }}
                className="w-md-auto"
              >
                Apply to your dream job
              </Button>
            </div>
          </div>
        )}
        {showResumePopup && (
          <ResumeSelectionPopup
            resumes={resumes}
            onSelectResume={handleResumeSelect}
            show={true}
            onClose={() => setShowResumePopup(false)}
            userName={userName} // Pass userName
            userId={userId} // Pass userId
            isLoading={isResumesLoading}
          />
        )}
      </div>
    </DashboardLayout>
  );
};

export default CandidateJobs;
